import { render } from "./DataValues.vue?vue&type=template&id=1f2ef28b"
import script from "./DataValues.vue?vue&type=script&lang=js"
export * from "./DataValues.vue?vue&type=script&lang=js"

import "./DataValues.vue?vue&type=style&index=0&id=1f2ef28b&lang=css"

import exportComponent from "/Users/abinop/code/Filisia-Dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__